export default () => ({
    state: true,
    init() {
        setTimeout(() => {
            this.state = false;
        }, 100)

    }
});